//#region IMAGES
import avatar from './images/avatar.png'
import female_avatar from './images/female_place_holder.jpg'
import male_avatar from './images/male_place_holder.jpg'
import logo from './images/optima-logo-main.png'
import logo_menu from './images/optima-logo-menu.png'
import login_avatar from './images/login-avatar.png'
import basic_file_icon from "./images/basicFileIcon.png";
import optimon from "./images/optimon.png";
import optimon_icon from "./images/optimon-ico.png";
export const Images = {
    avatar, female_avatar, male_avatar, logo, login_avatar, basic_file_icon, optimon, logo_menu, optimon_icon
}
//#endregion

//#region SOUNDS
import boop from './sounds/boop.mp3'
export const Sounds = {boop}
//#endregion

//#region STYLES
import './fonts/style.css'
//#endregion

//#region Restriction icons
import green_o from './images/restrictions/green-o.png'
import red_c from './images/restrictions/red-c.png'
import yellow_a from './images/restrictions/yellow-a.png'
import blue_d from './images/restrictions/blue-d.png'
import blue_ad from './images/restrictions/blue-ad.png'
import dc from './images/restrictions/dc.png'
import green_o_t from './images/restrictions/greenOtransparent.png'
import red_c_t from './images/restrictions/redCtransparent.png'
import yellow_a_t from './images/restrictions/yellowAtransparent.png'
import blue_d_t from './images/restrictions/blueDtransparent.png'
import blue_ad_t from './images/restrictions/blueADtransparent.png'
import dc_t from './images/restrictions/dc-transparent.png'
export const RestrictionIcons = [red_c, yellow_a, blue_d, blue_ad, green_o, dc]
export const RestrictionIconsTransparent = [red_c_t, yellow_a_t, blue_d_t, blue_ad_t, green_o_t, dc_t]
//#endregoin

//#Region apartment images
import defaultApartment from "./images/defaultApartmentImage.jpg";
export const ApartmentImages = {defaultApartment};
//#endregion